import cx from 'classnames';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import styles from './ReportsPage.scss';
import typography from '~styles/typography.scss';
import { useQuery } from '@tanstack/react-query';
import { getReports } from './apiHelpers';

export const ReportsPage = () => {
  const { id: restaurantId } = useRestaurant();

  const { data: { metabaseDashboardUrl, trafficReportUrl } = {} } = useQuery({
    queryKey: [restaurantId, 'reports'],
    queryFn: () => getReports(restaurantId),
  });

  if (!metabaseDashboardUrl && !trafficReportUrl) {
    return (
      <div>
        <h2 className={cx(typography.h4, styles.panelTitle)}>Reports</h2>
        <p>No reports configured for your account. Please contact support.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className={cx(typography.h4, styles.panelTitle)}>Reports</h2>
      <div>
        {metabaseDashboardUrl && (
          <section className={styles.section}>
            <iframe
              title="7-day Overview"
              width="100%"
              height="100%"
              src={metabaseDashboardUrl}
              frameBorder="0"
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          </section>
        )}

        {trafficReportUrl && (
          <section className={styles.section}>
            <h2 className={cx(typography.h4, styles.title)}>
              Web Traffic Report
            </h2>
            <iframe
              title="Traffic Report"
              width="100%"
              height="100%"
              src={trafficReportUrl}
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          </section>
        )}
      </div>
    </div>
  );
};
